export default __webpack_public_path__ + "static/media/undraw_Logic_re_nyb4.b9134f1f.svg";